// eslint-disable-next-line @typescript-eslint/ban-ts-comment
// @ts-nocheck
import React, { forwardRef, Ref } from "react";
import { IconProps, Svg } from "@/frameworks/designStuff/components/Contents/Icon";
const SvgSort24 = forwardRef(({ size, title, desc, titleid, descid, ...props }: IconProps, ref: Ref<SVGSVGElement>) => {
	let ariaLabelledBy = titleid ? titleid : "";
	ariaLabelledBy += desc && descid ? ` ${descid}` : "";
	ariaLabelledBy = ariaLabelledBy ? ariaLabelledBy : undefined;
	props["aria-labelledby"] = ariaLabelledBy;
	return (
		<Svg
			width={size}
			height={size}
			viewBox="0 0 24 24"
			xmlns="http://www.w3.org/2000/svg"
			title={title}
			titleid={titleid}
			desc={desc}
			descid={descid}
			aria-labelledby={ariaLabelledBy}
			aria-hidden={!ariaLabelledBy}
			ref={ref}
			{...props}
		>
			{!!title && <title id={titleId}>{title}</title>}
			{!!desc && <desc id={descId}>{desc}</desc>}
			<path
				fillRule="evenodd"
				clipRule="evenodd"
				d="M14 6C14.4142 6 14.75 6.33579 14.75 6.75C14.75 7.16421 14.4142 7.5 14 7.5H5C4.58579 7.5 4.25 7.16421 4.25 6.75C4.25 6.33579 4.58579 6 5 6H14ZM10.875 11C11.2892 11 11.625 11.3358 11.625 11.75C11.625 12.1642 11.2892 12.5 10.875 12.5H5C4.58579 12.5 4.25 12.1642 4.25 11.75C4.25 11.3358 4.58579 11 5 11H10.875ZM8.5 16.75C8.5 16.3358 8.16421 16 7.75 16H5C4.58579 16 4.25 16.3358 4.25 16.75C4.25 17.1642 4.58579 17.5 5 17.5H7.75C8.16421 17.5 8.5 17.1642 8.5 16.75ZM14.4697 16.0303C14.1768 15.7374 14.1768 15.2626 14.4697 14.9697C14.7626 14.6768 15.2374 14.6768 15.5303 14.9697L17.25 16.6891V7.5C17.25 7.08579 17.5858 6.75 18 6.75C18.4142 6.75 18.75 7.08579 18.75 7.5V16.6891L20.4697 14.9697C20.7359 14.7034 21.1526 14.6792 21.4462 14.8971L21.5303 14.9697C21.8232 15.2626 21.8232 15.7374 21.5303 16.0303L18.5303 19.0303C18.2374 19.3232 17.7626 19.3232 17.4697 19.0303L14.4697 16.0303Z"
			/>
		</Svg>
	);
});
SvgSort24.defaultProps = {
	size: 24,
	focusable: false,
	"aria-hidden": true,
	role: "img",
	fill: "currentcolor"
};
export default SvgSort24;
